export function fullNameOf(u: {
  displayName: string;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
}): string {
  if (!u.middleName || !u.firstName) return u.displayName;
  return [u.firstName, u.middleName, u.lastName].filter(Boolean).join(' ');
}
